var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6A552DE2-6CE8-450C-8AB3-AB0BF563FF46") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-798.000000, -1197.000000)",
    fill: "#1A1A1A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IconTasks",
    transform: "translate(798.320312, 1197.442017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375,0 L4.21875,0.84375 L1.96875,3.09375 L1.546875,3.4453125 L1.125,3.09375 L0,1.96875 L0.84375,1.125 L1.546875,1.86328125 L3.375,0 Z M6.046875,0.984375 L13.359375,0.984375 L13.359375,2.109375 L6.046875,2.109375 L6.046875,0.984375 Z M3.375,4.5 L4.21875,5.34375 L1.96875,7.59375 L1.546875,7.9453125 L1.125,7.59375 L0,6.46875 L0.84375,5.625 L1.546875,6.36328125 L3.375,4.5 Z M6.046875,5.484375 L13.359375,5.484375 L13.359375,6.609375 L6.046875,6.609375 L6.046875,5.484375 Z M3.375,9 L4.21875,9.84375 L1.96875,12.09375 L1.546875,12.4453125 L1.125,12.09375 L0,10.96875 L0.84375,10.125 L1.546875,10.8632812 L3.375,9 Z M6.046875,9.984375 L13.359375,9.984375 L13.359375,11.109375 L6.046875,11.109375 L6.046875,9.984375 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.5c3fd555834c6de6537a85a2719bd396.svg";
export { ForwardRef as ReactComponent };